<h1>Albion Online Journals Calculator</h1>
<div class="flex-container-column" style="width: 100%">
  <mat-card>
    <mat-card-content>
      <p>This tools allow you to see the results of delivering journals to laborers in 3 different scenarios.</p>
      <p>Click on the table cells to load up the details, where you can set custom prices. When you set a price manually, they update across all journals.</p>
    </mat-card-content>
  </mat-card>
  <div class="flex-container-row" style="width: 100%; align-items: start; margin-bottom: 15px">
    <form [formGroup]="journalsFormGroup" class="flex-container-row">
      <!-- MARK: Refresh -->
      <button
        class="form-item-button"
        style="align-self: center; margin: 0px"
        mat-mini-fab
        (click)="refreshPricesAndCreateResults()"
        [disabled]="!enableRefreshPricesButton"
        color="primary"
        matTooltip="Refresh Prices"
        aria-label="Refresh Prices"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <!-- MARK: Scenario Select -->
      <mat-form-field style="min-width: 360px">
        <mat-label>Scenario</mat-label>
        <mat-select [formControl]="journalsFormGroup.controls.scenario">
          @for (scenario of scenarios; track $index) {
            <mat-option [value]="scenario" style="font-size: 12px">
              {{ scenario }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- MARK: Happiness -->
      <mat-form-field>
        <mat-label>Happiness</mat-label>
        <mat-select [formControl]="journalsFormGroup.controls.happiness">
          @for (happiness of [1, 1.1, 1.125, 1.15, 1.175, 1.2, 1.225, 1.5]; track $index) {
            <mat-option [value]="happiness"> {{ (happiness ?? 0) * 100 | number: '1.2-2' }} % </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- MARK: Buy Location -->
      <mat-form-field>
        <mat-label>Buy Location</mat-label>
        <mat-select [formControl]="journalsFormGroup.controls.buyLocationForm">
          @for (location of locations; track $index) {
            <mat-option [value]="location">
              {{ location.displayName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- MARK: Buy Price Type -->
      <mat-form-field>
        <mat-label>Buy Price Type</mat-label>
        <mat-select [formControl]="journalsFormGroup.controls.buyTypeForm">
          @for (priceType of priceTypes; track $index) {
            <mat-option [value]="priceType">
              {{ priceType.friendlyName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- MARK: Sell Location -->
      <mat-form-field>
        <mat-label>Sell Location</mat-label>
        <mat-select [formControl]="journalsFormGroup.controls.sellLocationForm">
          @for (location of locations; track $index) {
            <mat-option [value]="location">
              {{ location.displayName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- MARK: Sell Price Type -->
      <mat-form-field>
        <mat-label>Sell Price Type</mat-label>
        <mat-select [formControl]="journalsFormGroup.controls.sellTypeForm">
          @for (priceType of priceTypes; track $index) {
            <mat-option [value]="priceType">
              {{ priceType.friendlyName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-checkbox style="margin-right: 10px" [formControl]="journalsFormGroup.controls.isPremium">Premium</mat-checkbox>
    </form>
  </div>

  <!-- MARK: Results -->

  @if (selectedJournalResult) {
    <div style="display: flex; flex-direction: column">
      <div style="display: flex; flex-direction: column">
        <!-- MARK: Buy -->
        <div class="title">BUY</div>
        <div style="display: flex; flex-direction: row; flex-wrap: wrap">
          @if (journalsFormGroup.controls.scenario.value === 'Buy Full, Sell Mats') {
            <!-- MARK: Full Journal -->
            <mat-card class="card">
              <div style="display: flex; flex-direction: column">
                <div style="display: flex; justify-content: center; width: 75; height: auto">
                  <img
                    [src]="imageService.getItemImageUrl(selectedJournalResult.fullJournal.uniqueName, undefined, 75)"
                    [alt]="selectedJournalResult.fullJournal.localizedName"
                  />
                </div>
                <div>
                  <span>{{ selectedJournalResult.fullJournal.localizedName }}</span>
                  <app-copy-text-button [text]="selectedJournalResult.fullJournal.localizedName"></app-copy-text-button>
                  <app-check-price-button [itemUniqueName]="selectedJournalResult.fullJournal.uniqueName"></app-check-price-button>
                </div>
                <div class="entry">
                  <div>x 1&nbsp;</div>
                  <div>for {{ selectedJournalResult.fullJournalBuyPrice.price | number: '1.0-0' }} each</div>
                </div>
                <div class="entry">
                  <mat-form-field>
                    <mat-label>Custom Price</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      step="1"
                      [(ngModel)]="selectedJournalResult.fullJournalBuyPrice.price"
                      (ngModelChange)="onPriceChange(selectedJournalResult.fullJournal.uniqueName, 'buy', $event)"
                    />
                  </mat-form-field>
                </div>
                <div class="entry">
                  <div>Setup fee:&nbsp;</div>
                  <div>{{ selectedJournalResult.fullJournalBuySetupFee | number: '1.0-0' }} each</div>
                </div>
                <div class="entry">
                  <div>Result:&nbsp;</div>
                  <div>{{ selectedJournalResult.fullJournalBuyResult | number: '1.0-0' }}</div>
                </div>
              </div>
            </mat-card>
          } @else {
            <!-- MARK: Empty Journal -->
            <mat-card class="card">
              <div style="display: flex; flex-direction: column">
                <div style="display: flex; justify-content: center; width: 75; height: auto">
                  <img
                    [src]="imageService.getItemImageUrl(selectedJournalResult.emptyJournal.uniqueName, undefined, 75)"
                    [alt]="selectedJournalResult.emptyJournal.localizedName"
                  />
                </div>
                <div>
                  <span>{{ selectedJournalResult.emptyJournal.localizedName }}</span>
                  <app-copy-text-button [text]="selectedJournalResult.emptyJournal.localizedName"></app-copy-text-button>
                  <app-check-price-button [itemUniqueName]="selectedJournalResult.emptyJournal.uniqueName"></app-check-price-button>
                </div>
                <div class="entry">
                  <div>x 1&nbsp;</div>
                  <div>for {{ selectedJournalResult.emptyJournalBuyPrice.price | number: '1.0-0' }} each</div>
                </div>
                <div class="entry">
                  <mat-form-field>
                    <mat-label>Custom Price</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      step="1"
                      [(ngModel)]="selectedJournalResult.emptyJournalBuyPrice.price"
                      (ngModelChange)="onPriceChange(selectedJournalResult.emptyJournal.uniqueName, 'buy', $event)"
                    />
                  </mat-form-field>
                </div>
                <div class="entry">
                  <div>Setup fee:&nbsp;</div>
                  <div>{{ selectedJournalResult.emptyJournalBuySetupFee | number: '1.0-0' }}</div>
                </div>
                <div class="entry">
                  <div>Result:&nbsp;</div>
                  <div>{{ selectedJournalResult.emptyJournalBuyResult | number: '1.0-0' }}</div>
                </div>
              </div>
            </mat-card>
          }
        </div>
        <!-- MARK: Sell -->
        <div class="title">SELL</div>
        <div style="display: flex; flex-direction: row; flex-wrap: wrap">
          @if (journalsFormGroup.controls.scenario.value === 'Buy Empty, Sell Full') {
            <!-- MARK: Full Journal -->
            <mat-card class="card">
              <div style="display: flex; flex-direction: column">
                <div style="display: flex; justify-content: center; width: 75; height: auto">
                  <img
                    [src]="imageService.getItemImageUrl(selectedJournalResult.fullJournal.uniqueName, undefined, 75)"
                    [alt]="selectedJournalResult.fullJournal.localizedName"
                  />
                </div>
                <div>
                  <span>{{ selectedJournalResult.fullJournal.localizedName }}</span>
                  <app-copy-text-button [text]="selectedJournalResult.fullJournal.localizedName"></app-copy-text-button>
                  <app-check-price-button [itemUniqueName]="selectedJournalResult.fullJournal.uniqueName"></app-check-price-button>
                </div>
                <div class="entry">
                  <div>x 1&nbsp;</div>
                  <div>for {{ selectedJournalResult.fullJournalSellPrice.price | number: '1.0-0' }} each</div>
                </div>
                <div class="entry">
                  <mat-form-field>
                    <mat-label>Custom Price</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      step="1"
                      [(ngModel)]="selectedJournalResult.fullJournalSellPrice.price"
                      (ngModelChange)="onPriceChange(selectedJournalResult.fullJournal.uniqueName, 'sell', $event)"
                    />
                  </mat-form-field>
                </div>
                <div class="entry">
                  <div>Setup fee:&nbsp;</div>
                  <div>{{ selectedJournalResult.fullJournalSellSetupFee | number: '1.0-0' }}</div>
                </div>
                <div class="entry">
                  <div>Sales Taxes:&nbsp;</div>
                  <div>{{ selectedJournalResult.fullJournalSellTax | number: '1.0-0' }}</div>
                </div>
                <div class="entry">
                  <div>Result:&nbsp;</div>
                  <div>{{ selectedJournalResult.fullJournalSellResult | number: '1.0-0' }}</div>
                </div>
              </div>
            </mat-card>
          } @else {
            <!-- MARK: Empty Journal -->
            <mat-card class="card">
              <div style="display: flex; flex-direction: column">
                <div style="display: flex; justify-content: center; width: 75; height: auto">
                  <img
                    [src]="imageService.getItemImageUrl(selectedJournalResult.emptyJournal.uniqueName, undefined, 75)"
                    [alt]="selectedJournalResult.emptyJournal.localizedName"
                  />
                </div>
                <div>
                  <span>{{ selectedJournalResult.emptyJournal.localizedName }}</span>
                  <app-copy-text-button [text]="selectedJournalResult.emptyJournal.localizedName"></app-copy-text-button>
                  <app-check-price-button [itemUniqueName]="selectedJournalResult.emptyJournal.uniqueName"></app-check-price-button>
                </div>
                <div class="entry">
                  <div>x 1&nbsp;</div>
                  <div>for {{ selectedJournalResult.emptyJournalSellPrice.price | number: '1.0-0' }} each</div>
                </div>
                <div class="entry">
                  <mat-form-field>
                    <mat-label>Custom Price</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      step="1"
                      [(ngModel)]="selectedJournalResult.emptyJournalSellPrice.price"
                      (ngModelChange)="onPriceChange(selectedJournalResult.emptyJournal.uniqueName, 'sell', $event)"
                    />
                  </mat-form-field>
                </div>
                <div class="entry">
                  <div>Setup fee:&nbsp;</div>
                  <div>{{ selectedJournalResult.emptyJournalSellSetupFee | number: '1.0-0' }}</div>
                </div>
                <div class="entry">
                  <div>Sales Taxes:&nbsp;</div>
                  <div>{{ selectedJournalResult.emptyJournalSellTax | number: '1.0-0' }}</div>
                </div>
                <div class="entry">
                  <div>Result:&nbsp;</div>
                  <div>{{ selectedJournalResult.emptyJournalSellResult | number: '1.0-0' }}</div>
                </div>
              </div>
            </mat-card>
          }
          @if (!(journalsFormGroup.controls.scenario.value === 'Buy Empty, Sell Full')) {
            @for (loot of selectedJournalResult.lootsWithSellPrices; track $index) {
              <!-- MARK: Loot -->
              <mat-card class="card">
                @if (loot.loot.item) {
                  <div style="display: flex; flex-direction: column">
                    <div style="display: flex; justify-content: center; width: 75; height: auto">
                      <img [src]="imageService.getItemImageUrl(loot.loot.uniqueName ?? '', undefined, 75)" [alt]="loot.loot.item.localizedName" />
                    </div>
                    <div>
                      <span>{{ loot.loot.item.localizedName }}</span>
                      <app-copy-text-button [text]="loot.loot.item.localizedName"></app-copy-text-button>
                      <app-check-price-button [itemUniqueName]="loot.loot.uniqueName ?? ''"></app-check-price-button>
                    </div>
                    <div class="entry">
                      <div>x {{ loot.amount | number: '1.4-4' }}&nbsp;</div>
                      <div>for {{ loot.price.price | number: '1.0-0' }} each</div>
                    </div>
                    <div class="entry">
                      <mat-form-field>
                        <mat-label>Custom Price</mat-label>
                        <input
                          matInput
                          type="number"
                          min="0"
                          step="1"
                          [(ngModel)]="loot.price.price"
                          (ngModelChange)="onPriceChange(loot.loot.uniqueName ?? '', 'sell', $event)"
                        />
                      </mat-form-field>
                    </div>
                    <div class="entry">
                      <div>Setup fee:&nbsp;</div>
                      <div>{{ loot.setupFeeCost | number: '1.0-0' }}</div>
                    </div>
                    <div class="entry">
                      <div>Sales Taxes:&nbsp;</div>
                      <div>{{ loot.salesTaxesCost | number: '1.0-0' }}</div>
                    </div>
                  </div>
                }
                <!-- MARK: Silver -->
                @if (loot.silver > 0) {
                  <div class="entry">
                    <div>Silver:&nbsp;</div>
                    <div>{{ loot.silver | number: '1.0-0' }}</div>
                  </div>
                }
                <!-- MARK: Result -->
                <div class="entry">
                  <div>Result:&nbsp;</div>
                  <div>{{ loot.result | number: '1.0-0' }}</div>
                </div>
              </mat-card>
            }
          }
        </div>
      </div>
    </div>
  }

  <!-- MARK: Table -->
  <div class="mat-elevation-z8 table">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Journal Type</th>
        <td mat-cell *matCellDef="let group">
          <div style="display: flex; align-items: center">
            @if (getJournalResultFromGroup(group, 8)?.fullJournal; as fullJournal) {
              <div style="width: 50; height: auto">
                <img [src]="imageService.getItemImageUrl(fullJournal.uniqueName, undefined, 50)" [alt]="fullJournal.localizedName" />
              </div>
              {{ removeFirstWord(fullJournal.localizedName) }}
              <!-- <app-copy-text-button [text]="fullJournal.localizedName"></app-copy-text-button>
              <app-check-price-button [itemUniqueName]="fullJournal.uniqueName"></app-check-price-button> -->
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="t3">
        <th mat-header-cell *matHeaderCellDef>T3</th>
        <td mat-cell *matCellDef="let group" style="cursor: pointer" (click)="selectJournalResult(group, 3)">
          @if (getJournalResultFromGroup(group, 3); as result) {
            <div style="display: flex; align-items: center; justify-content: center">
              {{ result.results.result | number: '1.0-0' }}
              @if (result.hasMissingPrices) {
                <mat-icon style="height: 15px; width: auto" color="warn" matTooltip="Missing Prices!">warning</mat-icon>
              }
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="t4">
        <th mat-header-cell *matHeaderCellDef>T4</th>
        <td mat-cell *matCellDef="let group" style="cursor: pointer" (click)="selectJournalResult(group, 4)">
          @if (getJournalResultFromGroup(group, 4); as result) {
            <div style="display: flex; align-items: center; justify-content: center">
              {{ result.results.result | number: '1.0-0' }}
              @if (result.hasMissingPrices) {
                <mat-icon style="height: 15px; width: auto" color="warn" matTooltip="Missing Prices!">warning</mat-icon>
              }
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="t5">
        <th mat-header-cell *matHeaderCellDef>T5</th>
        <td mat-cell *matCellDef="let group" style="cursor: pointer" (click)="selectJournalResult(group, 5)">
          @if (getJournalResultFromGroup(group, 5); as result) {
            <div style="display: flex; align-items: center; justify-content: center">
              {{ result.results.result | number: '1.0-0' }}
              @if (result.hasMissingPrices) {
                <mat-icon style="height: 15px; width: auto" color="warn" matTooltip="Missing Prices!">warning</mat-icon>
              }
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="t6">
        <th mat-header-cell *matHeaderCellDef>T6</th>
        <td mat-cell *matCellDef="let group" style="cursor: pointer" (click)="selectJournalResult(group, 6)">
          @if (getJournalResultFromGroup(group, 6); as result) {
            <div style="display: flex; align-items: center; justify-content: center">
              {{ result.results.result | number: '1.0-0' }}
              @if (result.hasMissingPrices) {
                <mat-icon style="height: 15px; width: auto" color="warn" matTooltip="Missing Prices!">warning</mat-icon>
              }
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="t7">
        <th mat-header-cell *matHeaderCellDef>T7</th>
        <td mat-cell *matCellDef="let group" style="cursor: pointer" (click)="selectJournalResult(group, 7)">
          @if (getJournalResultFromGroup(group, 7); as result) {
            <div style="display: flex; align-items: center; justify-content: center">
              {{ result.results.result | number: '1.0-0' }}
              @if (result.hasMissingPrices) {
                <mat-icon style="height: 15px; width: auto" color="warn" matTooltip="Missing Prices!">warning</mat-icon>
              }
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="t8">
        <th mat-header-cell *matHeaderCellDef>T8</th>
        <td mat-cell *matCellDef="let group" style="cursor: pointer" (click)="selectJournalResult(group, 8)">
          @if (getJournalResultFromGroup(group, 8); as result) {
            <div style="display: flex; align-items: center; justify-content: center">
              {{ result.results.result | number: '1.0-0' }}
              @if (result.hasMissingPrices) {
                <mat-icon style="height: 15px; width: auto" color="warn" matTooltip="Missing Prices!">warning</mat-icon>
              }
            </div>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['name', 't3', 't4', 't5', 't6', 't7', 't8']; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name', 't3', 't4', 't5', 't6', 't7', 't8']"></tr>
    </table>
  </div>
</div>
